import { Card, CardContent } from '@/shared/components/ui/card'
import { Input } from '@/shared/components/ui/input'
import { Textarea } from '@/shared/components/ui/textarea'
import { UserCircle } from 'lucide-react'
import { Character } from '@storyverse/shared'
import { FormField } from './FormField'
import React from 'react'

interface CharacterCoreIdentityProps {
    formData: Partial<Character>
    setFormData: React.Dispatch<React.SetStateAction<Partial<Character>>>
}

export const CharacterCoreIdentity: React.FC<CharacterCoreIdentityProps> = ({ formData, setFormData }) => {
    return (
        <Card className="overflow-hidden border-border/50 shadow-sm bg-muted/5">
            <CardContent className="p-6 space-y-6">
                <div className="flex items-center gap-2 border-b pb-4 mb-2">
                    <UserCircle className="w-5 h-5 text-primary" />
                    <h3 className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Core Identity</h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <FormField label="Full Name" helperText="The character's complete canonical name.">
                        <Input
                            value={formData.fullname || ''}
                            onChange={(e) => setFormData(p => ({ ...p, fullname: e.target.value }))}
                            placeholder="e.g. John 'The Ghost' Doe"
                            className="bg-background border-primary/10 transition-all focus:border-primary/40 font-medium h-10"
                        />
                    </FormField>
                    <FormField label="Nickname" helperText="What others call them informally.">
                        <Input
                            value={formData.nickname || ''}
                            onChange={(e) => setFormData(p => ({ ...p, nickname: e.target.value }))}
                            placeholder="Nickname"
                            className="bg-background border-primary/10 transition-all focus:border-primary/40 h-10"
                        />
                    </FormField>
                    <FormField label="Gender" helperText="How the character identifies.">
                        <Input
                            value={formData.gender || ''}
                            onChange={(e) => setFormData(p => ({ ...p, gender: e.target.value }))}
                            placeholder="Gender"
                            className="bg-background border-primary/10 transition-all focus:border-primary/40 h-10"
                        />
                    </FormField>
                </div>

                <FormField label="Fundamental Backstory" helperText="Core events that remain true across all timelines and variants.">
                    <Textarea
                        value={formData.core_backstory || ''}
                        onChange={(e) => setFormData(p => ({ ...p, core_backstory: e.target.value }))}
                        placeholder="Write the bedrock of this character's history..."
                        className="min-h-[100px] bg-background border-primary/10 transition-all focus:border-primary/40 text-sm leading-relaxed"
                    />
                </FormField>
            </CardContent>
        </Card>
    )
}
